/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { FundDto, FundDtoFromJSON, FundDtoFromJSONTyped, FundDtoToJSON } from "./FundDto";
import {
  FundHistoryLoanDtoFromDeferredIncome,
  FundHistoryLoanDtoFromDeferredIncomeFromJSON,
  FundHistoryLoanDtoFromDeferredIncomeFromJSONTyped,
  FundHistoryLoanDtoFromDeferredIncomeToJSON,
} from "./FundHistoryLoanDtoFromDeferredIncome";
import {
  FundLoanDtoFromFund,
  FundLoanDtoFromFundFromJSON,
  FundLoanDtoFromFundFromJSONTyped,
  FundLoanDtoFromFundToJSON,
} from "./FundLoanDtoFromFund";

/**
 *
 * @export
 * @interface FundLoanDto
 */
export interface FundLoanDto {
  /**
   *
   * @type {string}
   * @memberof FundLoanDto
   */
  id: string;
  /**
   *
   * @type {FundHistoryLoanDtoFromDeferredIncome}
   * @memberof FundLoanDto
   */
  fromDeferredIncome: FundHistoryLoanDtoFromDeferredIncome | null;
  /**
   *
   * @type {FundLoanDtoFromFund}
   * @memberof FundLoanDto
   */
  fromFund: FundLoanDtoFromFund | null;
  /**
   *
   * @type {FundDto}
   * @memberof FundLoanDto
   */
  toFund: FundDto;
  /**
   *
   * @type {number}
   * @memberof FundLoanDto
   */
  amount: number;
  /**
   *
   * @type {Date}
   * @memberof FundLoanDto
   */
  returnAt: Date;
  /**
   *
   * @type {Date}
   * @memberof FundLoanDto
   */
  createdAt: Date;
  /**
   *
   * @type {string}
   * @memberof FundLoanDto
   */
  comment: string;
  /**
   *
   * @type {number}
   * @memberof FundLoanDto
   */
  remainsAmount: number;
}

export function FundLoanDtoFromJSON(json: any): FundLoanDto {
  return FundLoanDtoFromJSONTyped(json, false);
}

export function FundLoanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundLoanDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    fromDeferredIncome: FundHistoryLoanDtoFromDeferredIncomeFromJSON(json["fromDeferredIncome"]),
    fromFund: FundLoanDtoFromFundFromJSON(json["fromFund"]),
    toFund: FundDtoFromJSON(json["toFund"]),
    amount: json["amount"],
    returnAt: new Date(json["returnAt"]),
    createdAt: new Date(json["createdAt"]),
    comment: json["comment"],
    remainsAmount: json["remainsAmount"],
  };
}

export function FundLoanDtoToJSON(value?: FundLoanDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    fromDeferredIncome: FundHistoryLoanDtoFromDeferredIncomeToJSON(value.fromDeferredIncome),
    fromFund: FundLoanDtoFromFundToJSON(value.fromFund),
    toFund: FundDtoToJSON(value.toFund),
    amount: value.amount,
    returnAt: value.returnAt.toISOString(),
    createdAt: value.createdAt.toISOString(),
    comment: value.comment,
    remainsAmount: value.remainsAmount,
  };
}
